import { Typography, Box, Link, IconButton } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import QRCode from "react-qr-code"
import { getPublicPackageSlipReceiptRoute } from "../../../../../../../constants/routes"
import { MeetingDetailsOrder } from "../../../../../../nonAdminUser/reports/home/meetingServiceApi"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/pro-light-svg-icons"
import { Stack } from "@mui/system"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { useEnvironment } from "../../../../../../environment/envHooks"

const useStyles = makeStyles()((theme) => ({
    header: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: theme.spacing(2),
        flexWrap: "wrap",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "stretch",
        },
    },
    title: {
        fontWeight: 500,
        color: theme.palette.tailwind.slate[700],

        // slightly smaller on phones
        [theme.breakpoints.down("sm")]: {
            textAlign: "center",
            fontSize: theme.typography.h5.fontSize,
            lineHeight: 1.2,
            fontWeight: 700,
        },
    },
    digitalSlipContainer: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1.5),
        textAlign: "right",
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    },
    digitalSlipTextAndIcon: {
        color: "#757373",
        display: "inline-flex",
        alignItems: "center",
        gap: theme.spacing(0.5),
        // bigger tap target on phones
        [theme.breakpoints.down("sm")]: {
            fontSize: theme.typography.body1.fontSize,
        },
    },
    qrWrap: {
        width: 80,
        height: 80,
        flex: "0 0 auto",
        [theme.breakpoints.down("sm")]: {
            width: 100, // bigger on phones
            height: 100,
        },
    },
    // Make the whole text+icon area act like a link on mobile
    linkReset: {
        textDecoration: "none",
        "&:hover": { textDecoration: "none" },
    },
}))

type PackageSlipHeaderProps = {
    order: MeetingDetailsOrder
}

export default function PackageSlipHeader({ order }: PackageSlipHeaderProps) {
    const { classes } = useStyles()
    const { currentEnv } = useEnvironment()
    const slipUrl = `${currentEnv?.webapp?.baseUrl}${getPublicPackageSlipReceiptRoute(order.uid)}`

    return (
        <Box className={classes.header}>
            <LocalizedStrict id="production-package-slip-section-header-slip-title">
                <Typography variant="h4" component="h1" className={classes.title}>
                    Packing slip
                </Typography>
            </LocalizedStrict>

            <Box className={classes.digitalSlipContainer}>
                <Stack direction="row" alignItems="center" spacing={0.5} className={classes.digitalSlipTextAndIcon}>
                    <LocalizedStrict id="production-package-slip-section-header-digital-slip-title">
                        <Typography variant="body2" color="text.secondary" component="span">
                            Digital slip
                        </Typography>
                    </LocalizedStrict>
                    <IconButton size="small" aria-label="Open digital slip" sx={{ p: 0.25 }}>
                        <FontAwesomeIcon size="xs" icon={faArrowRight} />
                    </IconButton>
                </Stack>

                <Box className={classes.qrWrap}>
                    <QRCode
                        size={256}
                        style={{ height: "100%", width: "100%" }}
                        value={slipUrl}
                        viewBox="0 0 256 256"
                    />
                </Box>
            </Box>
        </Box>
    )
}
